import React from 'react'
import { useState,useEffect } from 'react'
import Title from '../../components/forms/title'
import Searchbar from '../../components/forms/searchbar'
import { Link } from 'react-router-dom'

const Pages = () => {
  const [pageList,setPageList] = useState([]);
  const [filterList,setFilterList] = useState([]);
  function filterFunction(value){
    if(value === ""){
      setFilterList(pageList);
    }
    else{
      const filted = pageList.filter((obj)=>{
        return Object.values(obj)
        .join(" ").toLowerCase()
        .includes(value.toLowerCase());
      })
      setFilterList(filted);
    }
  }
  useEffect(() => {
    setPageList([
      {name:'Home',url:'/',discription:'Root page of website.',id:'1'},
      {name:'Home IOS',url:'/',discription:'Root page of ios.',id:'2'},
      {name:'Search IOS',url:'/',discription:'Search page of ios.',id:'3'}
    ]);
    setFilterList([
      {name:'Home',url:'/',discription:'Root page of website.',id:'1'},
      {name:'Home IOS',url:'/',discription:'Root page of ios.',id:'2'},
      {name:'Search IOS',url:'/',discription:'Search page of ios.',id:'3'}
    ]);
  },[])
  
  return (
    <div className='form_container'>
      <Title Name='Pages' BackURL = {null}/>
      <div className='form_table_container'>
        <Searchbar Filter={filterFunction}/>
        <div className='form_item_row_container title'>
          <div className='form_item_row_container_itemfull' style={{width:'25%'}}>
            <p>Title</p>
          </div>
          <div className='form_item_row_container_item' style={{width:'25%'}}>
            <p>Url</p>
          </div>
          <div className='form_item_row_container_item' style={{width:'50%'}}>
            <p>Discription</p>
          </div>
        </div>
        {
          filterList.map((item,index)=>{
            return(
              <Link to={'edit/'+item.id}>
                <div className='form_item_row_container discription' key={index}>
                  <div className='form_item_row_container_itemfull' style={{width:'25%'}}>
                    <p>{item.name}</p>
                  </div>
                  <div className='form_item_row_container_item' style={{width:'25%'}}>
                    <p>{item.url}</p>
                  </div>
                  <div className='form_item_row_container_item' style={{width:'50%'}}>
                    <p>{item.discription}</p>
                  </div>
                </div>
              </Link>
            );
          })
        }
      </div>
    </div>
  )
}

export default Pages